import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadScanRecords } from '../actions/records'
import { loadMetrics, fetchScanSnapDetails } from '../actions/wellness'
import currentScanSelector from '../selectors/current_scan'

import Report from '../components/report/index.js'
import ComparisonReport from '../components/report/comparison'

export class ReportPage extends Component {
  componentDidMount() {
    this.props.loadScanRecords()
    this.props.loadMetrics()
    this.fetchSnapDetailsIfNeeded(this.props.currentScan)
  }

  componentDidUpdate(prevProps) {
    const prevScan = prevProps.currentScan
    const nextScan = this.props.currentScan

    if (nextScan !== prevScan) {
      this.fetchSnapDetailsIfNeeded(nextScan)
    }
  }

  fetchSnapDetailsIfNeeded(scan) {
    if (!scan) {
      return
    }

    const hwVersion =
      typeof scan.get === 'function' ? scan.get('hwVersion') : scan.hwVersion
    const recordId = typeof scan.get === 'function' ? scan.get('id') : scan.id

    if (hwVersion === 7 && recordId) {
      this.props.fetchScanSnapDetails(recordId)
    }
  }

  render() {
    return (
      <Switch>
        <Route
          path="/report/comparison"
          component={(props) => <ComparisonReport {...props} />}
        />
        <Route path="/report" component={(props) => <Report {...props} />} />
      </Switch>
    )
  }
}

ReportPage.propTypes = {
  loadScanRecords: PropTypes.func,
  loadMetrics: PropTypes.func,
  fetchScanSnapDetails: PropTypes.func,
  currentScan: PropTypes.object,
}

const mapStateToProps = (state) => ({
  currentScan: currentScanSelector(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { loadScanRecords, loadMetrics, fetchScanSnapDetails },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage)
